import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import IntegrationInstructionsOutlinedIcon from '@mui/icons-material/IntegrationInstructionsOutlined';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';

const rawMenuItems = [
  {
    title: "Test Deposits",
    icon: SavingsOutlinedIcon,
    href: "/DepositPortal/merchant_test_deposits",
    moduleKey: "Deposits",
  },
  {
    title: "Test Payouts",
    icon: SendOutlinedIcon,
    href: "/DepositPortal/merchant_test_payouts",
    moduleKey: "Payouts",
  },
  {
    title: "Integration",
    icon: IntegrationInstructionsOutlinedIcon,
    href: "/DepositPortal/integration",
    moduleKey: "Integration",
  },
  {
    title: "Change Password",
    icon: VpnKeyOutlinedIcon,
    href: "/DepositPortal/change_password",
    moduleKey: "Change Password",
  },
];

const TestData = () => {
  return rawMenuItems;
};

export default TestData;
